import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { config } from '../../../../config/config';
import { ImageService } from '../../../services/image.service';
import { bindFunctionsToThis } from '../../extensions';
import { DropDownComponent } from '../drop.down/drop.down.component';
import { DropDownTriggerComponent } from '../drop.down/trigger/drop.down.trigger.component';
import { FacebookLoginButtonComponent } from '../facebook.login.button/facebook.login.button.component';
import { GoogleLoginButtonComponent } from '../google.login.button/google.login.button.component';

@Component({
    selector: 'ig-social-login-popup',
    templateUrl: './social.login.popup.component.html',
    styleUrls: ['./social.login.popup.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SocialLoginPopupComponent {

    public isLoggedIn = false;
    public img = '';
    public fbLogo = config.fbLogo;
    public googleLogo = config.googleLogo;
    @Input() public text = '';
    @ViewChild('fb') public fbLoginBtn: FacebookLoginButtonComponent;
    @ViewChild('google') public googleLoginBtn: GoogleLoginButtonComponent;
    @ViewChild('wrap') public wrap: ElementRef;
    @ViewChild('popup') public dropdown: DropDownComponent;
    @ViewChild('profileImg') public profileImg: ElementRef;
    @Output() public onLoginStatusChanged = new EventEmitter<{ status: boolean, profileImg: string}>();
    @Output() public onDropdownShow = new EventEmitter<boolean>();

    constructor(public imageService: ImageService) {
        bindFunctionsToThis(this);

        this.fbLogo = this.imageService.imageSourceUrl(this.fbLogo);
        this.googleLogo = this.imageService.imageSourceUrl(this.googleLogo);
        // setTimeout(() => {
        //     if (this.isUserLoggedIn) {
        //         this.loginStatusChanged(true);
        //     }
        // }, 3000);
    }

    public static get isUserLoggedIn() {
        return GoogleLoginButtonComponent.isUserLoggedWithGoogle || FacebookLoginButtonComponent.isUserLoggedWithFacebook;
    }

    public static get userId() {
        if (GoogleLoginButtonComponent.isUserLoggedWithGoogle) {
            return GoogleLoginButtonComponent.googleUserId + '|google';
        }
        if (FacebookLoginButtonComponent.isUserLoggedWithFacebook) {
            return FacebookLoginButtonComponent.authResponse.authResponse.userID;
        }
        return null;
    }

    public static get profilePicture() {
        if (GoogleLoginButtonComponent.isUserLoggedWithGoogle) {
            return GoogleLoginButtonComponent.profilePicture;
        }
        if (FacebookLoginButtonComponent.isUserLoggedWithFacebook) {
            return FacebookLoginButtonComponent.profilePicture;
        }
    }

    public logout() {
        if (FacebookLoginButtonComponent.isUserLoggedWithFacebook) {
            this.fbLoginBtn.logout();
            // Facebook logout has problems on non-production env (because of the domain cannot be added in the App settings)
            this.onLoginStatusChanged.emit({ status: false, profileImg: null});
        }
        if (GoogleLoginButtonComponent.isUserLoggedWithGoogle) {
            this.googleLoginBtn.logout();
        }
        this.isLoggedIn = false;
        setTimeout(() => {
            this.wrap.nativeElement.style.display = 'block';
            this.profileImg.nativeElement.style.display = 'none';
            if (this.fbLoginBtn.profileImg) {
                this.fbLoginBtn.profileImg.nativeElement.style.display = 'none';
            }
        }, 1000);
    }

    public loginStatusChanged($event) {
        if ($event) {
            this.isLoggedIn = true;
            setTimeout(() => {
                this.wrap.nativeElement.style.display = 'none';
                this.profileImg.nativeElement.style.display = 'block';
                this.profileImg.nativeElement.src = SocialLoginPopupComponent.profilePicture;
            });
        }
        this.onLoginStatusChanged.emit({status: $event, profileImg: SocialLoginPopupComponent.profilePicture});
    }

    public dropdownShow() {
        this.onDropdownShow.emit();
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/social.login.popup/social.login.popup.component.ts